import { StdioServerTransport } from '@modelcontextprotocol/sdk/server/stdio.js';
import { BaseMcpServer } from './BaseMcpServer.js';

/**
 * 这是我们具体的 Stdio 服务器实现。
 * 它继承了 BaseMcpServer 的所有基础功能,并使用标准输入输出 (stdio) 进行通信。
 * 这是 MCP 服务器最常见的使用方式,适合通过 npx 或其他进程管理工具启动。
 */
export class SoraVideoStdioServer extends BaseMcpServer {
  private transport?: StdioServerTransport;

  constructor() {
    // super() 必须首先被调用,用来初始化父类 (BaseMcpServer)
    super();
  }

  // 实现父类中定义的抽象方法 start
  public async start(): Promise<void> {
    if (this.state === 'running') {
      console.error('[SoraStdioServer] Server is already running.', { type: 'error' });
      return;
    }

    console.error('[SoraStdioServer] Starting Sora Video MCP Server (Stdio Mode)...', { type: 'info' });
    this.state = 'running';

    // 创建一个 MCP 的 Stdio 传输层实例
    // Stdio 传输使用进程的标准输入输出进行通信
    this.transport = new StdioServerTransport();

    // 将我们的服务器核心逻辑与传输层连接起来
    await this.sdkServer.connect(this.transport);

    console.error('[SoraStdioServer] Sora Video MCP Server is ready and listening on stdin/stdout', {
      type: 'info'
    });
  }

  // 实现父类中定义的抽象方法 stop
  public async stop(): Promise<void> {
    if (this.state !== 'running' || !this.transport) {
      console.error('[SoraStdioServer] Server is not running or not initialized.', { type: 'warning' });
      return;
    }

    console.error('[SoraStdioServer] Stopping server...', { type: 'info' });
    this.state = 'stopping';

    // 关闭传输层
    await this.transport.close();
    this.transport = undefined;

    console.error('[SoraStdioServer] Server has been stopped.', { type: 'info' });
    this.state = 'idle';
  }
}
